import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, Card } from '@material-ui/core';
import { Modal } from 'antd';
import MainContainer from '../../../components/MainContainer';
import RoomSetupListPage from './RoomSetupList';
import RoomSetupModalPage from './RoomSetupModal';
import RoomSetupSearchRoomModal from './RoomSetupSearchRoomModal';
import RoomSetupSearchTypeModal from './RoomSetupSearchRoomTypeModal';
import './RoomSetup.css';

@inject('RoomSetupStore')
@observer
class RoomSetupPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
    }

    // ON CANCEL

    roomSetupModalOnCancel = () => {
        this.props.RoomSetupStore.setShowRoomSetupModal(false);
    }

    roomSearchModalOnCancel = () => {
        this.props.RoomSetupStore.setShowRoomSearchModal(false);
    }

    roomTypeSearchModalOnCancel = () => {
        this.props.RoomSetupStore.setShowRoomTypeSearchModal(false);
    }

    render() {
        const {
            showRoomSetupModal,
            roomSetupTitle,
            showRoomSearchModal,
            showRoomTypeSearchModal
        } = this.props.RoomSetupStore;

        return (
            <MainContainer title='Room Setup' menukey='room-setup'>
                <Modal
                    title={roomSetupTitle}
                    visible={showRoomSetupModal}
                    width={800}
                    footer={null}
                    onCancel={this.roomSetupModalOnCancel}
                    zIndex={1000}
                >
                    <RoomSetupModalPage />
                </Modal>

                <Modal
                    title='Search Room'
                    visible={showRoomSearchModal}
                    width={800}
                    footer={null}
                    onCancel={this.roomSearchModalOnCancel}
                    zIndex={2000}
                >
                    <RoomSetupSearchRoomModal />
                </Modal>

                <Modal
                    title='Search Room Type'
                    visible={showRoomTypeSearchModal}
                    width={800}
                    footer={null}
                    onCancel={this.roomTypeSearchModalOnCancel}
                    zIndex={2000}
                >
                    <RoomSetupSearchTypeModal />
                </Modal>

                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card style={{ height: 980, padding: 20, overflow: 'auto' }}>
                            <RoomSetupListPage />
                        </Card>
                    </Grid>
                </Grid>
            </MainContainer>
        )
    }
}

export default RoomSetupPage;